import { render, staticRenderFns } from "./zjzt_detail.vue?vue&type=template&id=09f0ddfe&scoped=true&"
import script from "./zjzt_detail.vue?vue&type=script&lang=js&"
export * from "./zjzt_detail.vue?vue&type=script&lang=js&"
import style0 from "./zjzt_detail.vue?vue&type=style&index=0&id=09f0ddfe&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f0ddfe",
  null
  
)

export default component.exports